<script lang="ts">
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import Icon from "@shared/svelte/Components/Icon.svelte";
</script>

<div data-grid-area="aside">
  <section class:fizz-space-between={$LayoutStore.isMobile}>
    <h2
      class:fizz-heading-4={$LayoutStore.isMobile}
      class:fizz-heading-2={$LayoutStore.isDesktop}
      class:fizz-stack-32={$LayoutStore.isDesktop}
    >
      Wholesale beverage ordering, made simple &amp; free!
    </h2>
    {#if $LayoutStore.isDesktop}
      <ul class="fizz-flow-32 fizz-stack-32">
        <li>
          <div class="fizz-flex-row-12 fizz-align-content-start">
            <Icon type="Tick" height="24" width="24" />
            <div>
              <p class="fizz-text-large fizz-stack-4">
                <strong>Save countless hours</strong>
              </p>
              <p class="fizz-text-medium">
                Manage your beverage program in half the time! Place orders with all your
                distributors in one click.
              </p>
            </div>
          </div>
        </li>
        <li>
          <div class="fizz-flex-row-12 fizz-align-content-start">
            <Icon type="Tick" height="24" width="24" />
            <div>
              <p class="fizz-text-large fizz-stack-4">
                <strong>Shop hundreds of distributor portfolios</strong>
              </p>
              <p class="fizz-text-medium">
                Get access to over 700+ distributor catalogs with up-to-date product information.
              </p>
            </div>
          </div>
        </li>
        <li>
          <div class="fizz-flex-row-12 fizz-align-content-start">
            <Icon type="Tick" height="24" width="24" />
            <div>
              <p class="fizz-text-large fizz-stack-4">
                <strong>Strengthen relationships with your sales reps</strong>
              </p>
              <p class="fizz-text-medium">
                Easily simplify essential business communication with your reps or accounts.
              </p>
            </div>
          </div>
        </li>
      </ul>
    {/if}
    <img
      src={window["C"].IMAGE_PATHS["signup-hero.png"]}
      alt="Sign up to Provi"
      class:fizz-margin-auto={$LayoutStore.isDesktop}
      width={$LayoutStore.isMobile ? 90 : undefined}
    />
  </section>
</div>
